import {isNil} from 'ramda';

import {DeliveryNoteItem} from '../types/DeliveryNoteDocumentPreviewFormDefinition';

export function checkForInvalidItems(items: DeliveryNoteItem[]): boolean {
  return items.some((item: DeliveryNoteItem) => {
    if (!item.isActive) {
      return false;
    }

    const hasInvalidFields =
      !item.number || !item.name || !item.manufacturer || !item.unit || !item.vat;

    const hasInvalidNumericFields =
      isNil(item.quantity) ||
      item.quantity <= 0 ||
      isNil(item.unitPrice) ||
      item.unitPrice <= 0 ||
      isNil(item.totalPrice) ||
      item.totalPrice <= 0;

    return hasInvalidFields || hasInvalidNumericFields;
  });
}
